<template>
  <div style="background-color: #f2f2f2; height: 100%">
    <div
      style="
        background-color: #fff;
        padding: 0px 20px;
        line-height: 50px;
        border-bottom: 1px solid #ddd;
      "
    >
      入住审核
    </div>
    <div style="padding: 20px">
      <div>
        <el-row>
          <el-button
            type="primary"
            :disabled="disabledAdd"
            @click.native="toggleModalAdd"
            >通过</el-button
          >
          <el-button
            type="success"
            :disabled="disabledEdit"
            @click="dialogFormVisible = true"
            >不通过</el-button
          >

          <div style="float: right">
            <el-input
              placeholder="请输入老人姓名"
              v-model="elderlyName"
              clearable
              @change="getList"
              style="margin: 0 10px; width: 200px"
            ></el-input>
            <el-button
              style="margin-left: 10px; float: right"
              type="primary"
              icon="el-icon-search"
              @click="getList"
              >搜索</el-button
            >
          </div>
        </el-row>
        <div style="clear: both"></div>
      </div>

      <div style="height: 10px"></div>

      <div>
        <template>
          <el-table
            :data="tableData"
            default-expand-all
            v-loading="loading"
            highlight-current-row
            @row-click="rowClick"
            :height="th"
            border
            style="width: 100%"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline>
                  <div
                    style="padding: 10px"
                    v-for="item in props.row.checkinAutoDiscountList"
                    :key="item"
                  >
                    <span style="color: #99a9bf; margin-left: 20px"
                      >{{ item.name }}:
                    </span>
                    <span style="color: #99999; margin-left: 20px"
                      >{{ item.discount / 100 }}%</span
                    >
                  </div>
                  <div
                    style="margin-left: 30px; color: #99999; line-height: 30px"
                    v-if="props.row.checkinCouponList.length > 0"
                  >
                    <div
                      class="checkinCharge"
                      v-for="(item, i) in props.row.checkinCouponList"
                      :key="i"
                    >
                      <span
                        >{{ item.coupons.name }}：{{
                          item.couponMoney
                        }}
                        元</span
                      >
                    </div>
                    <!-- <span style="margin-left:20px;">{{props.row.preferentialPrice}} 元/月</span> -->
                  </div>
                </el-form>
              </template>
            </el-table-column>

            <el-table-column prop="elderlyName" label="姓名"></el-table-column>

            <el-table-column
              prop="durationPlan"
              label="预住时常(天)"
            ></el-table-column>

            <el-table-column
              prop="priceMonth"
              label="原月费用/元"
            ></el-table-column>

            <el-table-column
              prop="priceMonthDeduction"
              label="折后月费用/元"
            ></el-table-column>

            <!-- <el-table-column prop="preferentialPrice"  label="优惠金额"></el-table-column> -->

            <el-table-column
              prop="couponMoney"
              :formatter="getCouponPriceMoney"
              label="优惠后月费用/元"
            >
            </el-table-column>

            <el-table-column prop="auditResult" label="审核状态">
              <template slot-scope="scope">
                <span style="color: red" v-if="scope.row.auditResult == 0"
                  >未审核</span
                >
                <span v-if="scope.row.auditResult == 1" style="color: #67c23a"
                  >通过</span
                >
                <span v-if="scope.row.auditResult == 2" style="color: #66b1ff"
                  >不通过</span
                >
              </template>
            </el-table-column>

            <el-table-column prop="type" label="入住类型">
              <template slot-scope="scope">
                <span style="color: red" v-if="scope.row.type == 0"
                  >正式入住</span
                >
                <span v-if="scope.row.type == 1" style="color: #67c23a"
                  >试住</span
                >
                <span v-if="scope.row.type == 2" style="color: #66b1ff"
                  >预约入住</span
                >
              </template>
            </el-table-column>

            <el-table-column prop="status" label="入住状态">
              <template slot-scope="scope">
                <span style="color: red" v-if="scope.row.status == 0"
                  >未入住</span
                >
                <span v-if="scope.row.status == 1" style="color: #67c23a"
                  >已入住</span
                >
                <span v-if="scope.row.status == 2" style="color: #66b1ff"
                  >已退住</span
                >
              </template>
            </el-table-column>

            <el-table-column
              prop="createTime"
              :formatter="formatterTime"
              width="180"
              label="登记时间"
            ></el-table-column>
          </el-table>

          <div style="text-align: left; background-color: #fff; padding: 10px">
            <div style="float: left; padding: 5px">
              共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）
            </div>
            <div style="float: left">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                @current-change="current_change"
              >
              </el-pagination>
            </div>
            <div style="clear: both"></div>
          </div>
        </template>
      </div>

      <el-dialog title="不通过" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item
            label="不通过原因"
            :label-width="formLabelWidth"
            required="noPassCause"
          >
            <el-input
              v-model="noPassCause"
              placeholder="请输入内容"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="toggleModalEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <Add
      ref="myAdd"
      v-show="showModalAdd"
      v-on:closeAdd="closeAdd"
      v-on:getList="getList"
    ></Add>
    <Edit
      ref="myEdit"
      v-show="showModalEdit"
      v-on:closeEdit="closeEdit"
      v-on:getList="getList"
    ></Edit>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import { getStaffCode, getMenuButton } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      loading: true,
      row: null,
      elderlyName: "",
      menuButtonList: null,
      disabledAdd: true,
      disabledEdit: true,
      showModalAdd: false,
      showModalEdit: false,
      searchBuild: "",
      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      noPassCause: "",
      dialogFormVisible: false,
    };
  },
  components: {
    Add,
    Edit,
  },
  created() {
    this.getList();
    this.getMenu();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {
    getMenu() {
      let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
      var menu = getMenuButton(list, this.$route.path);
      this.menuButtonList = JSON.stringify(menu);
      if (menu != null && menu.length > 0) {
        for (let i = 0; i < menu.length; i++) {
          if (menu[i].buttonName == "添加") {
            this.disabledAdd = false;
          }
        }
      }
    },
    rowClick(row) {
      this.row = row;
      // if (row.status == 1) {
      //   if (this.menuButtonList.indexOf("通过") != -1) {
      //     this.disabledAdd = false;
      //   }
      //   if (this.menuButtonList.indexOf("不通过") != -1) {
      //     this.disabledEdit = false;
      //   }
      // } else {
        this.disabledAdd = false;
        this.disabledEdit = false;
      // }
    },
    formatterTime(row, column, cellValue) {
      return cellValue ? cellValue.replace("T", " ").slice(0, 19) : null;
    },
    toggleModalAdd: function () {
      this.$confirm("确认通过, 是否继续?", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submit(1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    submit(isPass) {
      this.loading = true;
      this.$axios({
        method: "post",
        url: this.$institutionUrl + "Checkin/NeedVerifyCheck",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          checkinCode: this.row.checkinCode,
          isPass: isPass,
          noPassCause: this.noPassCause.trim(),
        },
      })
        .then((response) => {
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message({ type: "info", message: response.data.message });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCouponPriceMoney(row){
        let couponsPrice=0;
        row.checkinCouponList.forEach(element => {
            couponsPrice+=element.couponMoney
        });
        return (row.priceMonthDeduction*100-couponsPrice*100)/100;
    },
    toggleModalEdit: function () {
      if (this.noPassCause.trim() == "") {
        this.$message("请输入不通过原因");
        return;
      }
      this.submit(2);
      this.dialogFormVisible = false;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList() {
      this.loading = true;
      this.$axios({
        method: "post",
        url: this.$institutionUrl + "Checkin/NeedVerifyList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyName: this.elderlyName,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          this.loading = false;
          this.disabledEdit = true;
          if (response.data.error == 0) {
            console.log(response.data.data);
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message({ type: "info", message: response.data.message });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row > td {
  background-color: #218af3;
  color: #fff;
}
</style>
